import React from 'react';
import { industries } from '../mock/data';
import { ArrowRight } from 'lucide-react';

const IndustriesSection = () => {
  // Map industry IDs to routes
  const getIndustryRoute = (industryId) => {
    const routes = {
      'coworks': '/coworks',
      'inmobiliarias': '/inmobiliarias',
      'multifamilies': '/multifamily',
      'empresas': '#', // No page yet
      'gimnasios': '#'  // No page yet
    };
    return routes[industryId] || '#';
  };

  return (
    <section id="industrias" className="py-32 bg-gray-50 scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold mb-6 text-gray-900">
            Soluciones por Industria
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
            Cloudbase se adapta perfectamente a las necesidades únicas de cada industria con configuración flexible y módulos especializados.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {industries.slice(0, 5).map((industry) => (
            <div 
              key={industry.id}
              className="group bg-white hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={industry.image} 
                  alt={industry.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {industry.name}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {industry.description}
                </p>
                <a 
                  href={getIndustryRoute(industry.id)}
                  className="inline-flex items-center gap-2 text-green-600 font-semibold group-hover:gap-3 transition-all"
                >
                  Ver más
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;